<template>
  <button class="auto-comp-add-button" @click.prevent="$emit('click', $event)">
    <div class="auto-comp-spacer-line" v-if="!hideLine" />
    <div class="add-button-circle"></div>
    <div class="add-button-text">{{label}}</div>
  </button>
</template>

<script>
export default {
  name: 'AutomationRuleAddComponent',
  props: {
    hideLine: Boolean,
    label: {
      type: String,
      default: 'Add Component'
    }
  }
}
</script>